import { render, staticRenderFns } from "./Tick.vue?vue&type=template&id=1babcdc5&scoped=true&"
import script from "./Tick.vue?vue&type=script&lang=js&"
export * from "./Tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babcdc5",
  null
  
)

export default component.exports